import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Icon } from '@material-ui/core';
import { ReactComponent as EmptyCircle } from '../../base/images/empty_Circle.svg';
import { BasicTaskList } from '../styles/BasicTaskList';
import { useBasicDetails } from '../../store';
import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { TaskItemStatus } from '../constants/constants';
import { TaskItem } from '../../taskList/interfaces';

interface BasicProgressBarProps {
  data: TaskItem[];
}

const BasicProgressBar = (props: BasicProgressBarProps): JSX.Element => {
  const { data } = props;
  const {
    template: { settings },
  } = useBasicDetails();
  const classes = BasicTaskList(settings);
  const filteredData = [...data];
  filteredData.sort((x, y) => {
    return x.status === TaskItemStatus.COMPLETED ? -1 : y.status === TaskItemStatus.COMPLETED ? 1 : 0;
  });

  return (
    <>
      {filteredData.map((item, index) =>
        item?.status === TaskItemStatus.COMPLETED ? (
          <FontAwesomeIcon key={index} className={`${classes.progressIcon} ${classes.completedIcon}`} icon={faCircle} />
        ) : (
          <Icon key={index} className={`${classes.progressIcon} ${classes.emptyCircleIcon}`} color="inherit">
            <EmptyCircle />
          </Icon>
        ),
      )}
    </>
  );
};

export default BasicProgressBar;
